module.exports = __webpack_public_path__ + "img/NewsLetter.85dd41a0.svg";